export const LOGIN_REDIRECT_STORAGE_KEY = 'origin';
/**
 * Check if there is a pending redirect
 */
export const hasPendingLoginRedirect = () => localStorage.getItem(LOGIN_REDIRECT_STORAGE_KEY) !== null;
/**
 * Start a redirect after a successful login
 *
 * @internal
 */
export const _startLoginRedirect = (path) => localStorage.setItem(LOGIN_REDIRECT_STORAGE_KEY, path);
/**
 * Execute redirect after a successful login
 * @param redirect
 */
export const loginRedirect = (redirect) => {
    const origin = localStorage.getItem(LOGIN_REDIRECT_STORAGE_KEY);
    if (origin != null) {
        // avoid tab race conditions
        setTimeout(() => {
            clearRedirect();
        }, 5000);
        redirect(origin);
    }
};
/**
 * Cancel an existing redirect
 *
 * Could be called if something in auth is missing, like user not having discord or vrchat linked
 */
export const clearRedirect = () => localStorage.removeItem(LOGIN_REDIRECT_STORAGE_KEY);
//# sourceMappingURL=loginRedirect.js.map